import { Link } from 'react-router-dom';
import type { ArticleItem } from '@/mocks/articles';

interface ArticleCardProps {
  article: ArticleItem;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 rounded-2xl border border-background-200/70 hover:border-primary-200 overflow-hidden transition-all duration-300 cursor-pointer"
    >
      <div className="aspect-[16/9] overflow-hidden">
        <img
          src={article.image}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          title={`${article.title} - 九色导航`}
        />
      </div>
      <div className="p-5">
        <div className="flex items-center gap-2 mb-2">
          <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 font-medium whitespace-nowrap">
            {article.category}
          </span>
          <span className="text-xs text-foreground-400">{article.publishDate}</span>
          <span className="text-xs text-foreground-400">· 阅读{article.readTime}</span>
        </div>
        <h3 className="font-semibold text-sm text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
          {article.title}
        </h3>
        <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="mt-3 flex items-center gap-1.5 flex-wrap">
          {article.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="text-[10px] px-2 py-0.5 rounded-md bg-background-100 text-foreground-500 whitespace-nowrap">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}